import './PickArea.css'
import ContestantsArea from '../ContestantsArea';
import { useEffect, useState } from 'react';

function PickArea({girlsList, availableGirls, handleClick, selected}) { 
  return(
    <div className="pick_area">
      <div className="pick_area_container">
        <h2 className="subtitle"><strong className="highlighted">Pick</strong> your favorites</h2>
        <ContestantsArea availableGirls={availableGirls} handleClick={handleClick} girlSelected={selected}/>
      </div>
    </div>
  )
}

export default PickArea;